export default class Projects{
    constructor(name="",description="",visible="selected", type="unselected"){
        this.name=name
        this.description=description
        this.visible=visible
        this.type = type
    }
}